import { Radio as MuiRadio, RadioProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const RadioButton = ({
  mode = 'light',
  ...props
}: {
  mode?: 'light' | 'dark';
} & RadioProps) => {
  return <StyledRadio mode={mode} {...props} />;
};

const StyledRadio = styled(MuiRadio)<{
  mode: 'light' | 'dark';
}>(({ theme, mode }) => ({
  svg: {
    fill:
      mode === 'light' ? theme.palette.grey500 : theme.palette.white,
  },

  '&.Mui-checked': {
    svg: {
      fill:
        mode === 'light'
          ? theme.palette.primary.main
          : theme.palette.red400,
    },
  },
}));

export default RadioButton;
